export default "__VITE_ASSET__GhV3sIyG__"